import React from 'react';
import { Col, Row, Radio, Layout } from 'antd';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { login, signin } from 'constants/routes';

const pages = {
    login,
    signin
};

export default connect(null, { push })(
    ({ children, page, push }) => {
        
        return(
            <Layout>
                <Row className="controls m-t-30">
                    <Col>
                        <Radio.Group
                            value={page}
                            onChange={event => push(pages[event.target.value].path)}
                        >
                            <Radio.Button value="signin">Регистрация</Radio.Button>
                            <Radio.Button value="login">Авторизация</Radio.Button>
                        </Radio.Group>
                    </Col>
                </Row>
                { children }
            </Layout>
        )
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/landing/Authorization.js